import { useMemo, useRef } from 'react'
import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect'

/**
 * Returns a read-only ref object that is always up-to-date with the latest value.
 * This is useful when you need to access frequently updated values that aren't
 * used in the render function in an event handler or effect.
 */
export function useSyncedRef<T>(value: T): { readonly current: T } {
    const ref = useRef(value)

    useIsomorphicLayoutEffect(() => {
        ref.current = value
    })

    return useMemo(
        () =>
            Object.freeze({
                get current() {
                    return ref.current
                },
            }),
        [],
    )
}
